module.exports = __webpack_public_path__ + "static/media/kunal_chaudhari.a47f2de5.png";